
import React from 'react'
import icon from './svgs/licenceColored.svg'
import { BaseIcon } from './_base'

export const LicenceColoredIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
